import { Row } from 'app/design/primitives/box';
import { Button, PressableType } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';

import { useNavigation } from 'app/hooks/navigation';
import { useAllTags } from 'app/network/listing';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconChevronRight } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

export function TagPicker({
  selectedTagId,
  goBackTo,
  onPress,
}: {
  selectedTagId?: string | null;
  goBackTo: 'set-atom-then-close';
  onPress?: () => void;
}) {
  const { t } = useTranslation('listings-filters');
  const navigation = useNavigation();

  const { data: tags } = useAllTags();

  const selectedTag = tags?.find((tag) => tag.id === selectedTagId);

  const navigateToTagSelection = () => {
    navigation.navigate('tags', { goBackTo, selectedTag: selectedTagId ?? undefined }, { pop: true });
  };

  return (
    <Button onPress={onPress ?? navigateToTagSelection} pressableType={PressableType.GestureHandler} variant="plain">
      <Row
        alignItems="center"
        borderColor="border.secondary"
        borderRadius="radius.lg"
        borderWidth={1}
        flex={1}
        padding="spacing.general.x2"
        style={{
          height: 48,
          borderRadius: 24,
          backgroundColor: selectedTag ? theme.colors['surface.inverse.tertiary-neutral'] : undefined,
        }}
        width="100%"
      >
        <Text flex={1} fontSize={16} fontWeight={selectedTag ? '700' : undefined} paddingLeft="spacing.general.x2">
          {selectedTag ? selectedTag.tagName : t('tagsPlaceholder')}
        </Text>
        <IconChevronRight strokeWidth={ICON_STROKE_WIDTH} size={24} color={theme.colors['text.primary']} />
      </Row>
    </Button>
  );
}
